import MessageBroker from 'deprecated-shared-ui/components/message-broker';
import Messages from "@core/scripts/components/messages";
import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';

function loadData(ajaxUrl) {

    return fetchWithCSRF(ajaxUrl, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then((response) => {
            if (response.ok) {
                return response.text();
            }
            return '';
        })
        .then((data) => {
            const jsonData = JSON.parse(data);
            if (jsonData.redirect?.url?.startsWith("/")) {
                window.location = jsonData.redirect.url;
                return;
            }

            const additionalStyles = jsonData.additionalStyles;

            // remove line breaks
            const inlineStyles = additionalStyles?.replace(/\\n/g, "");

            if (inlineStyles) {
                //remove first and last quotation mark
                const slicedStyles = inlineStyles.slice(1, -1);
                const currentStyles = document.querySelector('[jsh-additional-styles]');
                currentStyles.innerText = currentStyles.innerText + slicedStyles;
            }

            const modelPayload = {
                model: jsonData.preactModel
            };

            MessageBroker.publish(Messages.DOM.CHANGED);
            return modelPayload;
        })
        .catch(() => {
            return undefined;
        });
}

export {
    loadData,
};
